import { render } from "./TabsPage.vue?vue&type=template&id=644f6407&scoped=true&ts=true"
import script from "./TabsPage.vue?vue&type=script&lang=ts"
export * from "./TabsPage.vue?vue&type=script&lang=ts"

import "./TabsPage.vue?vue&type=style&index=0&id=644f6407&scoped=true&lang=css"

import exportComponent from "/Users/pablo/Sites/buen-provecho-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644f6407"]])

export default __exports__